import { actionTypes } from '../index';
import { ETariffFilters } from '../initialState';

export const setTariffFilters = (filters: ETariffFilters[]) => ({
    type: actionTypes.SET_TARIFF_FILTERS,
    payload: filters,
});

export const addTariffFilter = (filter: ETariffFilters) => ({
    type: actionTypes.ADD_TARIFF_FILTER,
    payload: filter,
});

export const removeTariffFilter = (filter: ETariffFilters) => ({
    type: actionTypes.REMOVE_TARIFF_FILTER,
    payload: filter,
});

export const clearTariffFilter = () => ({
    type: actionTypes.CLEAR_TARIFF_FILTERS,
});
